document.addEventListener('DOMContentLoaded', function () {
  const nav = document.querySelector('.anni25_navs');
  if (!nav) return;

  const links = nav.querySelectorAll('.nav_list .nav_item a');
  const stickyOffset = nav.getBoundingClientRect().top + window.scrollY;
  // 目标区块顶部与吸顶区之间留的空白
  const SCROLL_GAP = 16;
  // 点击落点比判定线再往里一点，避免平滑滚动取整后差之毫厘判不上
  const SCROLL_SLACK = 4;

  function getStickyHeaderEl() {
    return (
      document.querySelector('.header-section:has(> #header-component[sticky])') ||
      document.querySelector('header-component')
    );
  }

  function getHeaderOffset() {
    const headerEl = getStickyHeaderEl();
    if (headerEl) {
      const rect = headerEl.getBoundingClientRect();
      // When header is stuck near the top, use its live bottom edge
      if (rect.top <= 1 && rect.bottom > 0) {
        return Math.round(rect.bottom);
      }
    }
    return parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
  }

  /**
   * 吸顶导航占掉的高度（含留白）。点击落点和滚动判定必须共用这一个值，
   * 否则点完标签后判定会认为还没滚到目标，选中态落到相邻的标签上
   */
  function getNavOffset() {
    return (nav.offsetHeight || 0) + SCROLL_GAP;
  }

  function syncStickyTop(isSticky) {
    if (!isSticky) {
      nav.style.removeProperty('top');
      return;
    }
    // Overlap 1px to hide subpixel seam against sticky header
    nav.style.top = `${Math.max(0, getHeaderOffset() - 1)}px`;
  }

  function setActiveLink(activeAnchor) {
    links.forEach(function (link) {
      link.closest('.nav_item')?.classList.toggle('active', link === activeAnchor);
    });
  }

  function getTargetEl(href) {
    if (!href || href.charAt(0) !== '#') return null;
    const className = href.slice(1);
    if (!className) return null;
    return document.querySelector('.' + CSS.escape(className));
  }

  window.addEventListener(
    'scroll',
    function () {
      const scrollTop = window.scrollY;
      const headerOffset = getHeaderOffset();
      const isSticky = scrollTop >= stickyOffset - headerOffset;

      nav.classList.toggle('form_top', isSticky);
      syncStickyTop(isSticky);

      let activeLink = null;
      let activeTop = -Infinity;
      const current = scrollTop + getNavOffset() + headerOffset;

      links.forEach(function (item) {
        const target = getTargetEl(item.getAttribute('href') || '');
        if (!target) return;

        const top = target.getBoundingClientRect().top + window.scrollY;
        if (current >= top && top >= activeTop) {
          activeTop = top;
          activeLink = item;
        }
      });

      // activeLink 为 null 说明已经滚到第一个目标区块上方，这时必须清掉选中：
      // 原来用 if (activeLink) 守着，null 时什么都不做，最后一个选中态会一直亮着
      setActiveLink(activeLink);
    },
    { passive: true }
  );

  links.forEach(function (link) {
    link.addEventListener('click', function (event) {
      const href = link.getAttribute('href') || '';
      const target = getTargetEl(href);
      if (!target) return;

      event.preventDefault();
      setActiveLink(link);

      const headerOffset = getHeaderOffset();
      const top =
        target.getBoundingClientRect().top +
        window.scrollY -
        headerOffset -
        getNavOffset() +
        SCROLL_SLACK;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
  });
});
